export const PAGE_PATH = '/balance';
